import React, { useState } from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { UploadIcon, ImageIcon, VideoIcon, CheckCircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function ResizerUpload() {
  const navigate = useNavigate();
  const [uploadedFile, setUploadedFile] = useState<string | null>(null);
  const [fileType, setFileType] = useState<'image' | 'video' | null>(null);
  const [detectedDimensions, setDetectedDimensions] = useState<string | null>(null);
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const type = file.type.startsWith('image/') ? 'image' : 'video';
      setFileType(type);
      setUploadedFile(URL.createObjectURL(file));
      setDetectedDimensions('1920 x 1080 (16:9)');
    }
  };
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1779">
      <Sidebar data-id="element-1780" />
      <main className="flex-1" data-id="element-1781">
        <Header data-id="element-1782" />
        <div className="px-6 py-8" data-id="element-1783">
          <div className="max-w-4xl mx-auto" data-id="element-1784">
            <div className="mb-6" data-id="element-1785">
              <button onClick={() => navigate('/creative-customizer')} className="text-sm text-blue-500 hover:text-blue-600 mb-2 transition-colors" data-id="element-1786">
                ← Back to Creative Customizer
              </button>
              <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1787">
                Creative Resizer
              </h1>
              <p className="text-gray-600" data-id="element-1788">
                Adapt existing creatives to different platform formats
              </p>
            </div>

            {!uploadedFile ? <div className="bg-white rounded-lg border border-gray-200 p-12" data-id="element-1789">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-12 text-center hover:border-gray-400 transition-colors" data-id="element-1790">
                  <UploadIcon className="mx-auto text-gray-400 mb-4" size={64} data-id="element-1791" />
                  <h3 className="text-lg font-medium text-gray-700 mb-2" data-id="element-1792">
                    Upload Your Creative
                  </h3>
                  <p className="text-sm text-gray-500 mb-6" data-id="element-1793">
                    Support for images (JPG, PNG) and videos (MP4, MOV)
                  </p>
                  <label className="inline-block bg-blue-500 text-white px-8 py-3 rounded-md cursor-pointer hover:bg-blue-600 font-medium transition-colors" data-id="element-1794">
                    Choose File
                    <input type="file" className="hidden" accept="image/*,video/*" onChange={handleFileUpload} data-id="element-1795" />
                  </label>
                  <p className="text-xs text-gray-500 mt-4" data-id="element-1796">
                    Maximum file size: 50MB
                  </p>
                </div>

                <div className="mt-8 grid grid-cols-2 gap-6" data-id="element-1797">
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-6" data-id="element-1798">
                    <h4 className="font-medium text-blue-900 mb-3" data-id="element-1799">
                      For Images
                    </h4>
                    <ul className="text-sm text-blue-800 space-y-2" data-id="element-1800">
                      <li data-id="element-1801">• Smart crop with focal point preservation</li>
                      <li data-id="element-1802">• Intelligent expansion to fill space</li>
                      <li data-id="element-1803">• Maintains image quality</li>
                    </ul>
                  </div>
                  <div className="bg-purple-50 border border-purple-200 rounded-lg p-6" data-id="element-1804">
                    <h4 className="font-medium text-purple-900 mb-3" data-id="element-1805">
                      For Videos
                    </h4>
                    <ul className="text-sm text-purple-800 space-y-2" data-id="element-1806">
                      <li data-id="element-1807">• AI subject tracking + smart crop</li>
                      <li data-id="element-1808">• Audio preservation</li>
                      <li data-id="element-1809">• Frame-by-frame optimization</li>
                    </ul>
                  </div>
                </div>
              </div> : <div className="space-y-6" data-id="element-1810">
                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1811">
                  <div className="flex items-center justify-between mb-4" data-id="element-1812">
                    <h3 className="font-medium text-gray-800" data-id="element-1813">
                      Uploaded Creative
                    </h3>
                    <CheckCircleIcon className="text-green-500" size={24} data-id="element-1814" />
                  </div>
                  <div className="flex items-center space-x-6" data-id="element-1815">
                    <div className="w-48 h-48 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-1816">
                      {fileType === 'image' ? <ImageIcon className="text-gray-400" size={64} data-id="element-1817" /> : <VideoIcon className="text-gray-400" size={64} data-id="element-1818" />}
                    </div>
                    <div className="flex-1" data-id="element-1819">
                      <p className="font-medium text-gray-800 mb-2" data-id="element-1820">
                        {fileType === 'image' ? 'Image File' : 'Video File'}
                      </p>
                      <div className="space-y-2 text-sm" data-id="element-1821">
                        <div className="flex items-center" data-id="element-1822">
                          <span className="text-gray-600 w-32" data-id="element-1823">
                            Dimensions:
                          </span>
                          <span className="font-medium text-gray-800" data-id="element-1824">
                            {detectedDimensions}
                          </span>
                        </div>
                        <div className="flex items-center" data-id="element-1825">
                          <span className="text-gray-600 w-32" data-id="element-1826">Type:</span>
                          <span className="font-medium text-gray-800" data-id="element-1827">
                            {fileType === 'image' ? 'Image' : 'Video'}
                          </span>
                        </div>
                      </div>
                      <button onClick={() => {
                    setUploadedFile(null);
                    setFileType(null);
                    setDetectedDimensions(null);
                  }} className="text-sm text-blue-500 mt-4 hover:text-blue-600 transition-colors" data-id="element-1828">
                        Change file
                      </button>
                    </div>
                  </div>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-id="element-1829">
                  <h4 className="font-medium text-green-900 mb-2" data-id="element-1830">
                    Ready to Resize
                  </h4>
                  <p className="text-sm text-green-800" data-id="element-1831">
                    Your creative has been analyzed. Continue to select target
                    formats for AI-powered resizing.
                  </p>
                </div>

                <div className="flex justify-between" data-id="element-1832">
                  <button onClick={() => navigate('/creative-customizer')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1833">
                    Cancel
                  </button>
                  <button onClick={() => navigate('/dealer/resizer/step-2')} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors" data-id="element-1834">
                    Continue to Select Formats
                  </button>
                </div>
              </div>}
          </div>
        </div>
      </main>
    </div>;
}